module.exports = __webpack_public_path__ + "static/stack-machine-49956d219ec1d8551fe348a49acd175f.svg";